export default {"id":"ec15df62","attrs":{"viewBox":"0 0 24 24","width":"24","height":"24"}}